module.exports = __webpack_public_path__ + "static/media/MasterYi.faee2a10.png";